import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useAuth from '../hooks/useAuth';
import MainLoader from "../components/MainLoader";
import axios from "../api/axios";
export default function MobileWebRedirect() {
  const location = useLocation();
  const { setAuth } = useAuth();
const navigate = useNavigate();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("code"); // one-time code from mobile
  
    if (code) {
      const exchangeCode = async () => {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_API}/user/exchange-code`,
            { code: code }
          );
  
  
          const { token, user } = response.data;
          if (token) {
            localStorage.setItem("token", token);
            setAuth(null)
            navigate("/", { replace: true });
          } else {
            alert("No token in response!");
          }
  
        } catch (err) {
          console.error("Error exchanging code:", err);
        }
      };
  
      exchangeCode(); // call inner async function
    } else {
      console.warn("No code found in URL");
      alert("No login code found. Please try again.");
    }
  }, []);
  

  return <MainLoader />;
}
